import axios from 'axios';
import config from '../config';

const API_URL = config.api.API_URL;

const getToken = () => {
  return localStorage.getItem('token');
};

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle errors globally
api.interceptors.response.use(
  response => response,
  error => {
    const message = error.response?.data?.message || error.message;
    if (error.response?.status === 401) {
      error.showMessage = 'Authentication required - please login';
    }
    return Promise.reject({...error, message});
  }
);

// Login function that matches backend API
export const loginUser = async (email, password) => {
  const response = await api.post('/api/login', { email, password });
  if (response.data.token) {
    localStorage.setItem('token', response.data.token);
  }
  if (response.data.username) {
    localStorage.setItem('username', response.data.username);
  }
  return response;
};

// Register function that matches backend API
export const registerUser = async (email, username, password) => {
  const response = await api.post('/api/register', { email, username, password });
  return response;
};

// Get user profile function
export const getUserProfile = async () => {
  const response = await api.get('/api/user/profile');
  return response;
};

// Google OAuth verification
export const verifyGoogleToken = async (token) => {
  const response = await api.post('/api/auth/google/verify', { token });
  return response;
};

const predictionApi = {
  loginUser,
  registerUser,
  getUserProfile,
  verifyGoogleToken,
};

export default predictionApi;
